<template>
  <div class="filter-control">
    <filter-by-period
      :label="'Obdobie'"
      ref="periodFilter"
      @period-filter-change-1="handlePeriodChange($event)"
    />
    <filter-by-employee
      v-if="role === 'alex_admin'"
      :label="'bankár'"
      ref="employeeFilter"
      :employees="financnici"
      @employee-filter-change="handleFinancnkChange($event)"
    />
<!--    <filter-by-conversion @filter-by-conversion="a($event)" :label="'stav'"/>-->
    <search-by-key ref="searchFilter" @filter-client-by-key="handleSearchChange($event)"/>
  </div>
</template>

<script>
import FilterByEmployee from "../../shared/FilterResults/FilterByEmployee";
import SearchByKey from "../../shared/FilterResults/SearchByKey";
import FilterByPeriod from "../../shared/FilterResults/FilterByPeriod.vue";
import FilterByConversion from "../../shared/FilterResults/FilterByConversion.vue";
import {mapGetters} from "vuex";

export default {
  name: "KlientiFiltersBar",
  components: {
    FilterByConversion,
    FilterByPeriod,
    SearchByKey,
    FilterByEmployee
  },
  computed: {
    effectiveBrokerId() {
      return this.role === 'alex_admin' ? this.financnikFilter : this.$store.getters['userState/getId'];
    },
    ...mapGetters({
      financnici: "clientState/getFinancnici",

      role: "userState/getRole"
    }),
  },
  methods: {
    resetFilters() {
      this.$refs.periodFilter.setDefaultValue();
      if (this.$refs.employeeFilter)
        this.$refs.employeeFilter.setDefaultValue();
      this.$refs.searchFilter.reset();
      this.financnikFilter = null;
      this.periodFilter = {};
      this.statisticsPeriodFilter = null;
    },
    handleFinancnkChange(financnik) {
      const financnikFilter = {financnik};
      this.financnikFilter = financnik;
      this.applyClientsFilter(financnikFilter);
      this.refreshAnalytics();
    },
    handleSearchChange(search) {
      const searchClientsType = "search";

      if (search) {
        const searchFilter = {
          search,
          financnik: this.effectiveBrokerId,
          ...this.periodFilter
        }

        this.$store.commit("clientState/registerClientConfigType", {
          type: searchClientsType,
          config: searchFilter
        });
        this.$store.dispatch("clientState/fetchAllClientsFromConfig");
      } else {
        this.$store.commit("clientState/removeClientsByType", searchClientsType);
      }
    },
    handlePeriodChange(period) {
      const {transformedClientsPeriod, transformedHistoryPeriod} = this.transformPeriodFilter(period);
      this.statisticsPeriodFilter = this.hasDateFilter(transformedHistoryPeriod)
        ? transformedHistoryPeriod
        : null;
      this.applyClientsFilter(transformedClientsPeriod);
      this.refreshAnalytics();
    },
    transformPeriodFilter(period) {
      const transformedClientsPeriod = {};
      const transformedHistoryPeriod = {}

      if (period.hasOwnProperty("gte") && period.gte) {
        transformedClientsPeriod.date_joined__gte = period.gte.split(" ").join("");
      } else {
        transformedClientsPeriod.date_joined__gte = null;
      }

      if (period.hasOwnProperty("lt") && period.lt) {
        transformedClientsPeriod.date_joined__lt = period.lt.split(" ").join("");
      } else {
        transformedClientsPeriod.date_joined__lt = null;
      }

      if (period.hasOwnProperty("stgte") && period.stgte) {
        transformedHistoryPeriod.date_joined__gte = period.stgte.split(" ").join("");
      } else {
        transformedHistoryPeriod.date_joined__gte = null;
      }

      if (period.hasOwnProperty("stlt") && period.stlt) {
        transformedHistoryPeriod.date_joined__lt = period.stlt.split(" ").join("");
      } else {
        transformedHistoryPeriod.date_joined__lt = null;
      }

      this.periodFilter = transformedClientsPeriod;
      return {transformedClientsPeriod, transformedHistoryPeriod};
    },
    applyClientsFilter(filter) {
      this.$store.commit("clientState/updateAllClientsConfigs", {...filter, financnik: this.effectiveBrokerId});
      this.$store.dispatch("clientState/fetchAllClientsFromConfig");
    },
    hasDateFilter(filter) {
      return Boolean(filter?.date_joined__gte || filter?.date_joined__lt);
    },
    refreshAnalytics() {
      const brokerFilter = this.effectiveBrokerId
        ? {financnik: this.effectiveBrokerId}
        : {};
      const current = {
        ...(this.periodFilter || {}),
        ...brokerFilter,
      };
      const previous = this.statisticsPeriodFilter
        ? {...this.statisticsPeriodFilter, ...brokerFilter}
        : null;

      this.$store.commit("clientState/setClientAnalyticsFilters", {current, previous});
      this.$store.dispatch("clientState/fetchClientAnalytics");
    },
  },
  data: () => ({
    financnikFilter: null,
    periodFilter: {},
    statisticsPeriodFilter: null,
  }),
}
</script>

<style scoped>

</style>
